<template>
  <div id="login" class="d-flex align-items-center justify-content-center">
    <div class="card mx-auto text-left">
      <div class="card-header font-medium text-uppercase">Login</div>
      <div class="card-body">
        <b-form @submit.prevent="onSubmit">
          <b-form-group
                  label="Email"
                  label-for="input-1">
            <b-form-input
                    id="input-1"
                    v-model="form.email"
                    type="email"
                    required/>
          </b-form-group>

          <b-form-group
                  class="position-relative"
                  label="Password"
                  label-for="input-2">
            <b-form-input
                    id="input-2"
                    v-model="form.password"
                    :type="show_pass ? 'text' : 'password'"
                    required/>
            <span class="password-show" :class="{active: show_pass}" @click="show_pass = !show_pass"></span>
          </b-form-group>

          <b-button type="submit" variant="primary" class="mx-auto btn-image mt-4">
            <img src="../assets/img/btn-icon.png"> <span>Login</span>
          </b-button>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapMutations} from 'vuex'

  export default {
    name: 'Login',
    data() {
      return {
        form: {
          email: '',
          password: ''
        },
        show_pass: false,
      }
    },
    mounted() {
      this.setPreloader(false)
      let self = this
      window.axios.get(process.env.VUE_APP_API_ENDPOINT + 'account')
        .then(res => {
          this.setUser(res.data.user)
          if (res.data.user.role === 'user') {
            setTimeout(function () {
              self.$router.push('/reports')
            }, 200)
          } else {
            setTimeout(function () {
              self.$router.push('/users')
            }, 200)
          }
        })
        .catch((e) => {
          this.logout()
        })
    },
    methods: {
      ...mapMutations([
        'setUser',
        'logout',
      ]),
      ...mapActions([
        'login',
        'setPreloader',
      ]),
      onSubmit() {
        this.login(this.form)
      }
    }
  }
</script>

<style scoped lang="scss">
  #login {
    height: calc(100% - 62px);
    .card { width: 488px; height: 353px; }
  }
</style>
